(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bienenliebe-honig-gallery-v4"] && !Shopify.designMode) return;
  try {
    const initializeBienenliebeGalleries = (root = document) => {
    root.querySelectorAll('media-gallery[data-bienenliebe-gallery]').forEach((gallery) => {
      if (gallery.dataset.blGalleryInitialized) return;
      gallery.dataset.blGalleryInitialized = 'true';
      const items = () => Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
      const current = () => Math.max(0, items().findIndex((item) => item.classList.contains('is-active')));
      const updateCounter = () => {
        const counter = gallery.querySelector('[data-bl-photo-current]');
        if (counter) counter.textContent = String(current() + 1);
      };
      const move = (step) => {
        const slides = items();
        if (!slides.length) return;
        const index = (current() + step + slides.length) % slides.length;
        gallery.setActiveMedia(slides[index].dataset.mediaId, false);
        updateCounter();
      };
      gallery.querySelectorAll('[data-bl-photo-step]').forEach((button) => {
        button.addEventListener('click', () => move(Number(button.dataset.blPhotoStep)));
      });
      gallery.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      let touchX = 0;
      let touchY = 0;
      let swiped = false;
      const viewer = gallery.querySelector('.blhc-photo-viewer');
      viewer.addEventListener('touchstart', (event) => {
        touchX = event.touches[0].clientX;
        touchY = event.touches[0].clientY;
        swiped = false;
      }, { passive: true });
      viewer.addEventListener('touchend', (event) => {
        const dx = event.changedTouches[0].clientX - touchX;
        const dy = event.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          move(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
      viewer.addEventListener('click', (event) => {
        if (!swiped) return;
        event.preventDefault();
        event.stopPropagation();
        swiped = false;
      }, true);
      new MutationObserver(updateCounter).observe(viewer, { attributes: true, subtree: true, attributeFilter: ['class'] });
      updateCounter();
    });
  };
  customElements.whenDefined('media-gallery').then(() => initializeBienenliebeGalleries());
  document.addEventListener('shopify:section:load', (event) => {
    customElements.whenDefined('media-gallery').then(() => initializeBienenliebeGalleries(event.target));
  });
  } catch(e) { console.error(e); }
})();

})();
